import React from 'react';
import store from '../../store/Store';
import actions from '../../actions/Actions';

import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import FormatItalicIcon from '@material-ui/icons/FormatItalic'
import FormatBoldIcon from '@material-ui/icons/FormatBold'
import DoneIcon from '@material-ui/icons/Done'
import EditIcon from '@material-ui/icons/Edit'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import SlideshowIcon from '@material-ui/icons/Slideshow'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation'
import TextFieldsIcon from '@material-ui/icons/TextFields'

import './editorMediaText.scss'

type editorMediaTextState = {
  article: any;
  menu: any;
  navigation: any;
  row: any;
  column: any;
  contentEditable: any;
  id: any;
}

type editorMediaTextProps = {
  article: any;
  menu: any;
  navigation: any;
  row: any;
  column: any;
  id: any;
}

class EditorMediaText extends React.Component<editorMediaTextProps, editorMediaTextState> {

  constructor(props) {
    super(props)

    this.state = {
      article: props.article,
      menu: props.menu,
      navigation: props.navigation,
      row: props.row,
      column: props.column,
      contentEditable: null,
      id: props.id
    }
  }

  componentDidMount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        menu: store.getState().menu,
        navigation: store.getState().navigation
      })
    })

    document.addEventListener("contextmenu", this.handleContextMenu.bind(this))
  }

  handleContextMenu = (event) => {
    // console.log('CONTEXT MENU')
    // console.log(event)

    const { article } = this.state

    event.preventDefault()

    let selection = window.getSelection().toString()

    // console.log(selection)

    selection !== undefined && selection !== null ? this.textContextMenu : null

    if (article.textContextMenu.open) {
      actions.articleActions.changeTextContextMenu({
        open: article.textContextMenu.open,
        posX: event.pageX,
        posY: event.pageY
      })
    } else {
      actions.articleActions.changeTextContextMenu({
        open: !article.textContextMenu.open,
        posX: event.pageX,
        posY: event.pageY
      })
    }
  }

  textContextMenu = () => {
    // console.log('TEXT CONTEXT MENU')
  }

  changeBoldText = (event) => {
    console.log('EditorMediaText - changeBoldText')

    this.textProcessing(1, event.target.value)

    console.log(window.getSelection())
    console.log(window.getSelection().getRangeAt(0))

    document.execCommand('bold')

    actions.articleActions.changeTextContextMenu({
      open: false
    })
  }

  onClickDone = () => {
    const {
      article,
      row,
      column
    } = this.state

    actions.articleActions.removeEditCell({
      index: article.info.currentPage,
      row,
      column
    })

    actions.articleActions.addPreviewCell({
      index: article.info.currentPage,
      row,
      column
    })
  }

  changeItalicText = (event) => {
    console.log('EditorMediaText - changeItalicText')

    this.textProcessing(2, event.target.value)

    console.log(event)
    console.log(event.target)
    console.log(event.target.value)
    console.log(event.target.innerHTML)

    console.log(window.getSelection())
    console.log(window.getSelection().getRangeAt(0))

    document.execCommand('italic')

    actions.articleActions.changeTextContextMenu({
      open: false
    })
  }

  closeTextContextMenu = () => {
    // console.log('CLOSE CONTEXT MENU')

    const { article } = this.state

    if (article.textContextMenu.open) {
      actions.articleActions.changeTextContextMenu({
        open: !article.textContextMenu.open,
        subMenuOpen: !article.textContextMenu.subMenuOpen ? article.textContextMenu.subMenuOpen : !article.textContextMenu.subMenuOpen,
        posX: 0,
        posY: 0
      })
    }
  }

  onChangeIndex = (selectedPage, lastPage) => {
    actions.editorActions.setEditorSelectedPage(selectedPage)
    actions.editorActions.setEditorPreviousPage(lastPage)
  }

  onClickParagraph = (event) => {
    // console.log('EditorMediaText - onClickParagraph')
    // console.log(event.target.value)
    // console.log(event.target)

    // this.setState({ contentEditable: event.target })

    this.state.contentEditable === undefined || this.state.contentEditable === null ? this.setState({ contentEditable: event.target }) : null
  }

  onInputParagraph = (event) => {
    console.log('EditorMediaText - onInputParagraph')
    console.log(event)
    console.log(event.target)
    console.log(event.target.innerHTML)

    this.textProcessing(0, event.target.innerHTML)
  }

  textProcessing = (format, text) => {
    const {
      article,
      menu,
      contentEditable,
      row,
      column
    } = this.state

    let textProcessed = text

    actions.articleActions.setInputText({
      index: article.info.currentPage,
      row,
      column,
      content: {
        languages: {
          german: menu.activeLanguage === 0 ? textProcessed : null, // Object
          english: menu.activeLanguage === 1 ? textProcessed : null
        }
      }
    })

    return textProcessed
  }

  onChangeParagraph = (event) => {
    // console.log('EditorMediaText - onChangeParagraph')
    // console.log(event.target.value)
  }

  onMouseOverParagraph = (event) => {
    // console.log('EditorMediaText - onOverParagraph')
    // console.log(event.target.value)
  }

  onMouseOutParagraph = (event) => {
    // console.log('EditorMediaText - onMouseOutParagraph')
    // console.log(event.target.value)
  }

  renderMediaPreview = (media, mediaIndex) => {
    let content = []

    content.push(
      <div>
        Content { media.content } { mediaIndex }
      </div>
    )

    return content
  }

  render() {
    const {
      article,
      menu,
      navigation,
      row,
      column
    } = this.state

    let edit = false
    let preview = false
    let content
    let index = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.edit && page.edit.map((item, index, array) => {
        return item.row === row && item.column === column ? edit = true : null
      })

      article.info.currentPage === page.index && page.preview && page.preview.map((item, index, array) => {
        return item.row === row && item.column === column ? preview = true : null
      })

      article.info.currentPage === page.index && page.media && page.media.map((item, index, array) => {
        if (item.row === row && item.column === column) {
          index = item.index
        }
        return item.row === row && item.column === column ? content = item.content : null
      })
    })

    // console.log('EditorMediaText')
    // console.log(edit)
    // console.log(preview)
    // console.log(content)

    return (
      <div
        className='EditorMediaText'
        style={{
          width: '100%',
          height: '100%'
        }}
      >

        {
          edit ? (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%',
                margin: 0,
                padding: 0
              }}
            >
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: '100%',
                  height: '100%',
                  maxHeight: '100%',
                  whiteSpace: 'pre-line',
                  margin: 0,
                  padding: 0,
                  textAlign: 'justify',
                  // textAlignLast: 'justify',
                  color: 'rgba(0, 0, 0, 255)',
                  backgroundColor: 'rgba(255, 255, 255, 0)',
                  resize: 'none',
                  overflow: 'hidden',
                  outline: '0 solid transparent'
                }}
                contentEditable={ edit }
                onClick={ this.onClickParagraph.bind(this) }
                onInput={ this.onInputParagraph.bind(this) }
                onChange={ this.onChangeParagraph.bind(this) }
                onMouseOver={ this.onMouseOverParagraph.bind(this) }
                onMouseOut={ this.onMouseOutParagraph.bind(this) }
              >

              </div>

              <IconButton
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0'
                }}
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.onClickDone.bind(this) }
              >
                <Icon>
                  <DoneIcon />
                </Icon>
              </IconButton>
            </div>
          ) : preview || article.preview ? (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%',
                margin: 0,
                padding: 0
              }}
            >
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  minWidth: '100%',
                  minHeight: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  textAlign: 'justify',
                  whiteSpace: 'pre-line',
                  margin: 0,
                  padding: 0,
                  color: 'rgba(0, 0, 0, 255)',
                  backgroundColor: 'rgba(255, 255, 255, 0)',
                  resize: 'none',
                  overflow: 'hidden',
                  outline: '0 solid transparent'
                }}
              >
                <IconButton
                  style={{
                    position: 'absolute',
                    bottom: '0',
                    right: '0'
                  }}
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => { actions.articleActions.removePreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    }) 
                  }}
                >
                  <Icon>
                    <CancelPresentationIcon />
                  </Icon>
                </IconButton>
              </div>
            </div>
          ) : (
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                minWidth: '100%',
                minHeight: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                textAlign: 'center',
                backgroundColor: 'rgba(150, 150, 150, 255)'
              }}
            >
              <div
                style={{
                  display: 'block',
                  position: 'absolute',
                  width: '150px',
                  height: '50px',
                  top: 'calc(50% - 75px)',
                  left: 'calc(50% - 75px)'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addPreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <TextFieldsIcon />
                  </Icon>
                </IconButton>
              </div>

              <div
                style={{
                  display: 'block',
                  position: 'absolute',
                  width: '150px',
                  height: '50px',
                  top: 'calc(50% - 25px)',
                  left: 'calc(50% - 75px)'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addPreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <SlideshowIcon />
                  </Icon>
                </IconButton>

                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addEditCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <EditIcon />
                  </Icon>
                </IconButton>

                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.removeMedia({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <DeleteForeverOutlinedIcon />
                  </Icon>
                </IconButton>
              </div>
            </div>
          )
        }

        {
          article.textContextMenu.open && edit ? (
            <div
              className='EditorTextContextMenu'
              style={{
                position: 'fixed',
                left: article && article.textContextMenu && !article.textContextMenu.fixed ? article.textContextMenu.posX : 0,
                top: article && article.textContextMenu && !article.textContextMenu.fixed ? article.textContextMenu.posY : article.textContextMenu.orientation === 0 ? 0 : 'calc(100% - 50px)',
                border: article.textContextMenu.open ? '1px solid black' : 'none',
                backgroundColor: 'rgba(255, 255, 255, 255)',
                zIndex: 1
              }}
            >

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.changeBoldText.bind(this) }
              >
                <Icon>
                  <FormatBoldIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.changeItalicText.bind(this) }
              >
                <Icon>
                  <FormatItalicIcon />
                </Icon>
              </IconButton>

            </div>
          ) : null
        }
        
      </div>
    );
  }
}

export default EditorMediaText;